<script>
export default {
  name: "DoctorNotes",

  data() {
    return {
      managementNotesDetails: {},
    };
  },

  props: {
    managementNotes: Array,
    chiefComplains: Array,
    historyofIllnesses: Array,
    physicalExams: Array,
    vitals: Array,
    dischargeSummary: Array,
    triageVitals: Array,
    sickOffNotes: Array,
    consultantRequest: Array,
    encounters: Array,
  },

  methods: {

      printMedicalFile() {
          window.print();
      },
  },
};
</script>
<template>
  <div class="w-full flex flex-wrap p-1">
    <div class="w-full p-1 hide--print">
      <span
        class="py-px px-3 font-medium bg-blue-800 text-white rounded text-xs mr-2"
        >Inpatient</span
      >
      <span
        class="py-px px-3 font-medium bg-blue-400 text-white rounded text-xs mr-2"
        >Outpatient</span
      >
      <span
        class="py-px px-3 font-medium bg-yellow-500 text-white rounded text-xs mr-2"
        >Triage</span
      >
      <span
        class="py-px px-3 font-medium bg-green-500 text-white rounded text-xs mr-2"
        >Discharge</span
      >
    </div>
    <div
      class="w-full bg-gray-100"
      v-for="encounter in encounters"
      :key="encounter.encounterId"
    >
      <div
        v-if="
          (vitals.length &&
            vitals.filter((vital) => vital.encounterId == encounter.encounterId)
              .length) ||
            (chiefComplains.length &&
              chiefComplains.filter(
                (complain) => complain.encounterId == encounter.encounterId
              ).length) ||
            (historyofIllnesses.length &&
              historyofIllnesses.filter(
                (hI) => hI.encounterId == encounter.encounterId
              ).length) ||
            (physicalExams.length &&
              physicalExams.filter(
                (pE) => pE.encounterId == encounter.encounterId
              ).length) ||
            (managementNotes.length &&
              managementNotes.filter(
                (mN) => mN.encounterId == encounter.encounterId
              ).length) ||
            (triageVitals.length &&
              triageVitals.filter(
                (triage) => triage.encounterId == encounter.encounterId
              ).length) ||
            (consultantRequest.length &&
              consultantRequest.filter(
                (cR) => cR.encounterId == encounter.encounterId
              ).length) ||
            (sickOffNotes.length &&
              sickOffNotes.filter(
                (sON) => sON.encounterID == encounter.encounterId
              ).length)
        "
        class="p-1 w-full rounded-t-md"
        :class="{
          'bg-blue-400': encounter.category == `OutPatient`,
          'bg-blue-800': encounter.category == `InPatient`,
          'bg-yellow-500': encounter.category == `Triage`,
        }"
      >
        <h5 class="font-bold text-white text-sm">
          <span class="mr-4">Encounter #{{ encounter.encounterId }}</span>
          <span>Visit #{{ encounter.visitNo }}</span>
        </h5>
      </div>
      <div
        v-if="
          (vitals.length &&
            vitals.filter((vital) => vital.encounterId == encounter.encounterId)
              .length) ||
            (chiefComplains.length &&
              chiefComplains.filter(
                (complain) => complain.encounterId == encounter.encounterId
              ).length) ||
            (historyofIllnesses.length &&
              historyofIllnesses.filter(
                (hI) => hI.encounterId == encounter.encounterId
              ).length) ||
            (physicalExams.length &&
              physicalExams.filter(
                (pE) => pE.encounterId == encounter.encounterId
              ).length) ||
            (managementNotes.length &&
              managementNotes.filter(
                (mN) => mN.encounterId == encounter.encounterId
              ).length) ||
            (triageVitals.length &&
              triageVitals.filter(
                (triage) => triage.encounterId == encounter.encounterId
              ).length) ||
            (consultantRequest.length &&
              consultantRequest.filter(
                (cR) => cR.encounterId == encounter.encounterId
              ).length) ||
            (sickOffNotes.length &&
              sickOffNotes.filter(
                (sON) => sON.encounterID == encounter.encounterId
              ).length)
        "
        class="w-full flex flex-wrap my-1"
      >
        <div class="md:w-1/5 w-full p-1 border">
          <h5 class="font-medium text-base">Stage:</h5>
        </div>
        <div class="md:w-4/5 w-full p-1 border">
          <h5 class="font-medium text-sm">{{ encounter.category }}</h5>
        </div>
        <div class="md:w-1/5 w-full p-1 border">
          <h5 class="font-medium text-base">Encounter Created By:</h5>
        </div>
        <div class="md:w-4/5 w-full p-1 border">
          <h5 class="font-medium text-sm">{{ encounter.userName }}</h5>
        </div>
        <div class="md:w-1/5 w-full p-1 border">
          <h5 class="font-medium text-base">Created At:</h5>
        </div>
        <div class="md:w-4/5 w-full p-1 border">
          <h5 class="font-medium text-sm">
            {{ encounter.sysDate | dateFormatDT }}
          </h5>
        </div>
      </div>
      <div
        class="w-full flex flex-row border my-px"
        v-if="
          vitals.length &&
            vitals.filter((vital) => vital.encounterId == encounter.encounterId)
              .length
        "
      >
        <div class="md:w-1/5 w-1/4 p-1">
          <h5 class="text-base font-bold">Vitals</h5>
        </div>
        <div class="md:w-4/5 w-3/4">
          <div
            class="w-full flex flex-row p-1 border-b"
            v-for="(vital, idx) in vitals.filter(
              (vital) => vital.encounterId == encounter.encounterId
            )"
            :key="idx"
          >
            <div class="w-1/3">
              <h5 class="font-medium text-sm">
                <span class="mr-3">Time:</span>
                <span>{{ vital.sysDate | dateFormatDT }}</span>
              </h5>
            </div>
            <div class="w-1/3">
              <h5 class="font-medium text-sm">
                <span class="mr-3">{{ vital.parameter }}:</span
                ><span>{{ vital.value }}</span>
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div
        class="w-full flex flex-wrap border my-px"
        v-if="
          chiefComplains.length &&
            chiefComplains.filter(
              (complain) => complain.encounterId == encounter.encounterId
            ).length
        "
      >
        <div class="md:w-1/5 w-1/4 p-1">
          <h5 class="font-bold">Chief Complains:</h5>
        </div>
        <div class="md:w-4/5 w-3/4 p-1" v-if="chiefComplains.length">
          <div
            v-for="(complain, idx) in chiefComplains.filter(
              (complain) => complain.encounterId == encounter.encounterId
            )"
            :key="idx"
          >
            <div v-html="complain.description" class="my-1"></div>
          </div>
        </div>
      </div>
      <div
        class="w-full flex flex-wrap border my-px"
        v-if="
          historyofIllnesses.length &&
            historyofIllnesses.filter(
              (hI) => hI.encounterId == encounter.encounterId
            ).length
        "
      >
        <div class="md:w-1/5 w-1/4 p-1">
          <h5 class="font-bold">History Of Illness</h5>
        </div>
        <div class="md:w-4/5 w-3/4 p-1">
          <div
            v-for="(historyofIllness, idx) in historyofIllnesses.filter(
              (hI) => hI.encounterId == encounter.encounterId
            )"
            :key="idx"
          >
            <div class="my-px" v-html="historyofIllness.historyofIllness"></div>
          </div>
        </div>
      </div>
      <div
        class="w-full flex flex-wrap border my-px"
        v-if="
          physicalExams.length &&
            physicalExams.filter(
              (pE) => pE.encounterId == encounter.encounterId
            ).length
        "
      >
        <div class="md:w-1/5 w-1/4 p-1">
          <h5 class="font-bold">Physical Exam</h5>
        </div>
        <div class="md:w-4/5 w-3/4 p-1">
          <div
            v-for="(physicalExam, idx) in physicalExams.filter(
              (pE) => pE.encounterId == encounter.encounterId
            )"
            :key="idx"
          >
            <div class="my-px" v-html="physicalExam.physicalExam"></div>
          </div>
        </div>
      </div>
      <div
        class="w-full flex flex-wrap border my-px"
        v-if="
          managementNotes.length &&
            managementNotes.filter(
              (mN) => mN.encounterId == encounter.encounterId
            ).length
        "
      >
        <div class="md:w-1/5 w-1/4 p-1">
          <h5 class="font-bold">Management Notes:</h5>
        </div>
        <div class="md:w-4/5 w-3/4 p-1">
          <div
            v-for="(note, idx) in managementNotes.filter(
              (mN) => mN.encounterId == encounter.encounterId
            )"
            :key="idx"
          >
            <div class="my-px" v-html="note.managementNotes"></div>
          </div>
        </div>
      </div>
      <div
        class="w-full flex flex-wrap border my-px"
        v-if="
          triageVitals.length &&
            triageVitals.filter(
              (triage) => triage.encounterId == encounter.encounterId
            ).length
        "
      >
        <div class="md:w-1/5 w-1/4 p-1">
          <h5 class="font-bold">Triage:</h5>
        </div>
        <div class="md:w-4/5 w-3/4">
          <div
            class="w-full flex flex-row p-1 border-b"
            v-for="(vital, idx) in triageVitals.filter(
              (vital) => vital.encounterId == encounter.encounterId
            )"
            :key="idx"
          >
            <div class="w-1/3">
              <h5 class="font-medium text-sm">
                <span class="mr-3">Time:</span>
                <span>{{ vital.sysDate | dateFormatDT }}</span>
              </h5>
            </div>
            <div class="w-1/3">
              <h5 class="font-medium text-sm">
                <span class="mr-3">{{ vital.parameter }}:</span>
                <span>{{ vital.value }}</span>
              </h5>
            </div>
          </div>
        </div>
      </div>
      <div
        class="w-full flex flex-wrap border my-px"
        v-if="
          consultantRequest.length &&
            consultantRequest.filter(
              (cR) => cR.encounterId == encounter.encounterId
            ).length
        "
      >
        <div class="md:w-1/5 w-1/4 p-1">
          <h5 class="font-bold">Consultation Request:</h5>
        </div>
        <div class="md:w-4/5 w-3/4 overflow-auto">
          <table class="table text-sm">
            <tbody>
              <tr>
                <th class="p-tiny">Clinic</th>
                <th class="p-tiny">Date</th>
                <th class="p-tiny">Physician</th>
                <th class="p-tiny">Comment</th>
              </tr>
              <tr v-for="cont in consultantRequest" :key="cont.cunsultationsId">
                <td class="p-tiny">{{ cont.clinic }}</td>
                <td class="p-tiny">{{ cont.txnDate | dateFormat }}</td>
                <td class="p-tiny">{{ cont.physician }}</td>
                <td class="p-tiny"><span v-html="cont.description"></span></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div
        class="w-full flex flex-wrap border my-px"
        v-if="
          sickOffNotes.length &&
            sickOffNotes.filter(
              (sON) => sON.encounterID == encounter.encounterId
            ).length
        "
      >
        <div class="md:w-1/5 w-1/4 p-1">
          <h5 class="font-bold text-base">Sick Off Note:</h5>
        </div>
        <div class="md:w-4/5 w-3/4 px-px">
          <div class="my-px" v-for="sOF in sickOffNotes" :key="sOF.id">
            <span v-html="sOF.description"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full p-1 text-right">
        <button 
            @click.prevent="printMedicalFile"
            class="btn-sm btn-primary text-xs">
                <i class="fa fa-print"></i> Print</button>
    </div>
  </div>
</template>
<style scoped>
@media print {
  .hide--print {
    display: none;
  }
  h5 {
    color: black;
  }
  th {
    color: black;
  }
}
</style>
